/** Specific vocabulary to be used to give repeatable content a distinct brand voice
 * @example
 * import { TuVocab } from '@sainsburys-tech/vocab'
 *
 * return (
 *   <Button>{ TuVocab.ADD_TO_TROLLEY }</Button>
 * )
 * @example
 * const Button = () => {
 * const { ADD_TO_TROLLEY } = useVocab()
 * return (
 *   <Button>{ ADD_TO_TROLLEY }</Button>
 * )
 */
const TuVocab = {
  BRAND_NAME: 'Tu',
  ADD_TO_TROLLEY: 'Add to basket',
  ITEM_CONTAINER: 'basket'
}

export default TuVocab
